// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3w-mm","content":"styles_content__2Uk_J","row":"styles_row__24OVx","footer":"styles_footer__1GOx0","phraseLength":"styles_phraseLength__2y9Rm"};